import { Typography } from '@chilecompra/react-kit/components'

import { Container } from '../Claims.styles'

/**
 * The ClaimsHeader component.
 */
const ClaimsHeader = () => (
  <Container direction="column" spacing={2}>
    <Typography fontWeight="bold" variant="h3">
      Ingreso de reclamo
    </Typography>

    <Typography variant="body1">
      Completa el formulario para ingresar un reclamo asociado a un proceso de compra. La
      información registrada será enviada al sistema de reclamos y permitirá mantener la
      trazabilidad de tu solicitud.
    </Typography>
  </Container>
)

export default ClaimsHeader
